import api from '../api'

export interface Skill {
  id: number
  name: string
  category: string
  description?: string
}

export interface UserSkill {
  id: number
  proficiency_level: number
  years_of_experience: number
  rate: number
  skill: Skill
}

interface UserSkillFormData {
  skill_id: number
  proficiency_level: number
  years_of_experience: number
}

export const skillsApi = {
  // Get all available skills
  getAll: async () => {
    const response = await api.get<{ skills: Skill[] }>('/skills')
    return response.data
  },

  // Get user's skills
  getUserSkills: async () => {
    const response = await api.get<{ skills: UserSkill[] }>('/user_skills')
    return response.data
  },

  // Add skill to user
  addUserSkill: async (data: UserSkillFormData) => {
    const response = await api.post<{ user_skill: UserSkill; message: string }>('/user_skills', { user_skill: data })
    return response.data
  },

  // Update user skill
  updateUserSkill: async (id: number, data: Partial<UserSkillFormData>) => {
    const response = await api.put<{ user_skill: UserSkill; message: string }>(`/user_skills/${id}`, { user_skill: data })
    return response.data
  },

  // Delete user skill
  deleteUserSkill: async (id: number) => {
    await api.delete(`/user_skills/${id}`)
  },
}
